"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingMaskSpinner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _LoadingMaskSpinner = require("./LoadingMaskSpinner.styles");
/**
 * @since 8.1.0
 */
var LoadingMaskSpinner = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_LoadingMaskSpinner.StyledLoadingMaskSpinner, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.LoadingMaskSpinner = LoadingMaskSpinner;
LoadingMaskSpinner.displayName = 'LoadingMaskSpinner';